import { render, staticRenderFns } from "./save-area.vue?vue&type=template&id=5f5f947c&scoped=true&lang=pug&"
import script from "./save-area.vue?vue&type=script&lang=ts&"
export * from "./save-area.vue?vue&type=script&lang=ts&"
import style0 from "./save-area.vue?vue&type=style&index=0&id=5f5f947c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5f947c",
  null
  
)

export default component.exports